<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>Contents</h1><ol><li id="level1-titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></li>
<li id="level1-toc"><a href="#/toc">Contents</a></li>
<li id="level1-front3"><a href="#/front01">Copyright</a></li>
<li id="level1-front4"><a href="#/front02">Dedication</a></li>
<li id="level1-front5"><a href="#/front03">Prologue</a></li>
<li id="c001"><a href="#/c001">spill</a>
</li>
<li id="c002"><span href="#/c002" title="Link target outside of Sample">simmer</span>
</li>
<li id="c003"><span href="#/c003" title="Link target outside of Sample">falter</span>
</li>
<li id="c004"><span href="#/c004" title="Link target outside of Sample">wither</span>
</li>
<li id="level1-back14"><span href="#/back01" title="Link target outside of Sample">Epilogue</span></li>
<li id="level1-back15"><span href="#/back02" title="Link target outside of Sample">Acknowledgements</span></li>
<li id="level1-back16"><span href="#/back03" title="Link target outside of Sample">Reading Group Guide</span></li>
<li id="level1-back17"><span href="#/back04" title="Link target outside of Sample">Sample Chapter from A LINE MADE BY WALKING</span></li>
<li id="level1-back18"><span href="#/back05" title="Link target outside of Sample">Buy the Book</span></li>
<li id="level1-back19"><span href="#/back06" title="Link target outside of Sample">About the Author</span></li>
<li id="level1-back20"><span href="#/back07" title="Link target outside of Sample">Connect with HMH</span></li></ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4c4f577c